export class UpdateBackupZeroEtlPolicyInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "multiResourceConfiguration",
            "baseName": "multiResourceConfiguration",
            "type": "MultiResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "singleResourceConfiguration",
            "baseName": "singleResourceConfiguration",
            "type": "SingleResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "accessConfiguration",
            "baseName": "accessConfiguration",
            "type": "BackupZeroEtlAccessConfiguration",
            "format": ""
        },
        {
            "name": "tableFilters",
            "baseName": "tableFilters",
            "type": "BackupZeroEtlFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateBackupZeroEtlPolicyInput.attributeTypeMap;
    }
    constructor() {
    }
}
